<div class="container">
  <div class="icon-container">
    <mat-icon
      mat-dialog-close
      class="as-pointer"
      svgIcon="ic-close-green"
    ></mat-icon>
  </div>
  <div class="image-container-wrapper as-column as-justify-center">
    <div class="image-container as-row as-justify-center">
      <img
        [style]="{
          transform: 'scale(' + imageScale + ')',
          'transform-origin': '50% 0'
        }"
        [src]="url"
        alt=""
      />
    </div>
    <div class="button-container">
      <button [disabled]="imageScale === 1" (click)="scaleDown()">
        <mat-icon svgIcon="ic-lupa-out"></mat-icon>
      </button>
      <button [disabled]="imageScale === 1.5" (click)="scaleUp()">
        <mat-icon svgIcon="ic-lupa-in"></mat-icon>
      </button>
    </div>
  </div>
</div>
